export const projects = [
  {
    id: "petinga",
    name: "Petinga",
    category: "Jogo educacional financeiro",
    status: "OnGoing",
    pitch:
      "Financial Game Lab com backend como fonte de verdade, arquitetura em camadas e documentacao extensa de regras.",
    stack: ["Laravel", "PHP", "PostgreSQL", "React", "Docker", "DDD/Clean Architecture"],
    commitWindow: "Sprints pragmaticos",
    commitRhythm: "Commits pequenos e orientados a contexto",
    projectLink: "https://petinga.app",
    repositoryUrl: "https://github.com/andremourapassos/petinga",
    commitStart: "2026-03-21",
    commitEnd: "2026-04-11",
    architectureDomains:
      "Backend como fonte de verdade em arquitetura em camadas (Clean + DDD), com frontend desacoplado e regras de dominio centralizadas.",
    roadmap:
      "Consolidar contrato HTTP, ampliar testes de dominio/fluxo e evoluir balanceamento e operacao do jogo.",
    withoutAiHours: 210,
    withAiHours: 96,
    withAiLabel: "96h",
    withoutAiLabel: "210h",
    icon: "P",
    mockTheme: "forest",
  },
  {
    id: "midea",
    name: "Midea",
    category: "Plataforma de analise de similaridade musical",
    status: "Paused",
    pitch:
      "Monorepo com API Laravel, engine Python e UI React para experimentos de analise de audio ponta a ponta.",
    stack: ["Laravel 12", "PHP", "Python", "FastAPI", "React 19", "TypeScript", "Vite", "Docker", "PostgreSQL"],
    commitWindow: "Ciclos curtos",
    commitRhythm: "Entrega por blocos funcionais",
    projectLink: "https://midea.local/project",
    repositoryUrl: "https://github.com/andremourapassos/midea",
    commitStart: "2026-01-11",
    commitEnd: "2026-04-11",
    architectureDomains:
      "Monorepo com midea-api (Laravel), midea-analysis-engine (Python/FastAPI) e midea-ui (React), integrados por contratos de pipeline.",
    roadmap:
      "Prioridade em validacao automatica de contratos API/engine, testes de integracao e observabilidade por experiment_id.",
    withoutAiHours: 120,
    withAiHours: 52,
    withAiLabel: "52h",
    withoutAiLabel: "120h",
    icon: "M",
    mockTheme: "amber",
  },
  {
    id: "cnpjwatcher",
    name: "CNPJWatcher",
    category: "MicroSaaS contabil",
    status: "OnGoing",
    pitch:
      "Plataforma para monitoramento de CNPJs com fila/scheduler, diff de snapshots e API paga com metering.",
    stack: ["Laravel 12", "PHP", "PostgreSQL", "React 19", "TypeScript", "Vite", "Docker"],
    commitWindow: "Roadmap objetivo",
    commitRhythm: "Sequencia direta de features",
    projectLink: "https://cnpjwatcher.app",
    repositoryUrl: "https://github.com/andremourapassos/cnpj-watcher",
    commitStart: "2026-03-15",
    commitEnd: "2026-04-11",
    architectureDomains:
      "Estrutura modular por dominio (Auth, Companies, Monitoring, ApiAccess, Billing) com multi-tenant, scheduler/queue e providers com fallback.",
    roadmap:
      "Expandir testes dos fluxos criticos, reforcar observabilidade operacional e otimizar escalabilidade da API externa paga.",
    withoutAiHours: 140,
    withAiHours: 61,
    withAiLabel: "61h",
    withoutAiLabel: "140h",
    icon: "CW",
    mockTheme: "deep",
  },
  {
    id: "consorcio_comparison",
    name: "Comparador de Consórcio",
    category: "Comparador financeiro local-first",
    status: "Ready",
    pitch: "Comparador de consórcio x financiamento (Price/SAC) com API local e persistencia em JSON.",
    stack: ["React", "Vite", "TypeScript", "Node.js", "Express", "JSON storage"],
    commitWindow: "Algumas horas",
    commitRhythm: "Alta intensidade, ponta a ponta",
    projectLink: "https://consorcio-comparison.local",
    repositoryUrl: "https://github.com/andremourapassos/consorcio-comparison",
    commitStart: "2026-04-09",
    commitEnd: "2026-04-11",
    architectureDomains:
      "Aplicacao local-first com frontend React/Vite e API Node/Express, persistindo estado em JSON sem banco relacional.",
    roadmap:
      "Projeto concluido no escopo atual, com margem para evolucao em simulacoes adicionais e comparativos exportaveis.",
    withoutAiHours: 40,
    withAiHours: 6,
    withAiLabel: "6h",
    withoutAiLabel: "40h",
    icon: "CC",
    mockTheme: "sunset",
  },
  {
    id: "samebloodscocktail",
    name: "Same Bloods Cocktail",
    category: "Landing musical multilingue",
    status: "Online",
    pitch:
      "Landing dedicada do projeto musical Same Bloods Cocktail, com i18n de rota e integracao de catalogo/SEO.",
    stack: ["React 19 (CRA)", "react-router-dom", "i18next", "SEO", "Node.js backend", "GraphQL playlist"],
    commitWindow: "Algumas horas",
    commitRhythm: "Alta intensidade, ponta a ponta",
    projectLink: "https://samebloodscocktail.com",
    repositoryUrl: "https://github.com/andremourapassos/same-bloods-cocktail",
    commitStart: "2026-04-10",
    commitEnd: "2026-04-11",
    architectureDomains:
      "Landing musical dedicada dentro do ecossistema principal, com i18n por rota, SEO e composicao de componentes visuais.",
    roadmap:
      "Evolucao continua de conteudo, assets e performance da experiencia musical em desktop e mobile.",
    withoutAiHours: 40,
    withAiHours: 6,
    withAiLabel: "6h",
    withoutAiLabel: "40h",
    icon: "SBC",
    mockTheme: "wine",
  },
  {
    id: "ai_projects_landing_page",
    name: "AI Projects Landing Page",
    category: "Portfolio interativo desktop/mobile",
    status: "Online",
    pitch:
      "Pagina de portfolio com metaphor desktop OS, experiencia mobile orientada a modal e narrativa de projetos com dados localizados.",
    stack: ["React 19 (CRA)", "i18next", "CSS Modules", "Component architecture", "UX responsiva"],
    commitWindow: "Iteracao continua",
    commitRhythm: "Ajustes frequentes de UX e conteudo",
    projectLink: "https://andremourapassos.com/ia-portfolio",
    repositoryUrl: "https://github.com/andremourapassos/andre-moura-passos",
    commitStart: "2026-04-01",
    commitEnd: "present",
    architectureDomains:
      "Composicao por camadas (domain/application/presentation), dados de portfolio centralizados, i18n por namespace e janelas modulares reutilizaveis.",
    roadmap:
      "Evoluir qualidade visual, consistencia cross-device, performance de renderizacao e governanca de conteudo multilingue.",
    withoutAiHours: 52,
    withAiHours: 21,
    withAiLabel: "21h",
    withoutAiLabel: "52h",
    icon: "APL",
    mockTheme: "gold",
  },
  {
    id: "youtube_white_label",
    name: "YouTube White-Label Sites",
    category: "SaaS white-label para criadores",
    status: "Backlog",
    pitch:
      "Plataforma white-label para youtubers: ao informar a URL do canal, o sistema gera um site com identidade visual proprietaria e dados sincronizados da API do YouTube.",
    stack: ["Laravel", "Node.js workers", "YouTube Data API", "React", "Template engine", "Multi-tenant SaaS"],
    commitWindow: "Planejamento ativo",
    commitRhythm: "Blueprint funcional por modulos",
    projectLink: "https://youtube-whitelabel.local",
    repositoryUrl: "",
    commitStart: "2026-04-12",
    commitEnd: "present",
    architectureDomains:
      "Core multi-tenant com provisionamento por workspace, pipeline de ingestao de dados do YouTube, temas white-label e publicacao automatizada por dominio customizado.",
    roadmap:
      "Validar MVP de onboarding por URL de canal, engine de temas, cache inteligente da API e fluxo de publicacao segura em dominios dos clientes.",
    withoutAiHours: 240,
    withAiHours: 102,
    withAiLabel: "102h",
    withoutAiLabel: "240h",
    icon: "YW",
    mockTheme: "rose",
  },
  {
    id: "andremourapassos",
    name: "Site Pessoal de André Moura Passos",
    category: "Ecossistema web pessoal",
    status: "Online",
    pitch:
      "Projeto principal com site pessoal, landing musical e backend com GraphQL/contato, em evolucao continua.",
    stack: ["React 19 (CRA)", "Node.js", "Express", "GraphQL", "i18n", "Vercel"],
    commitWindow: "Fluxo continuo",
    commitRhythm: "Incremental, releases frequentes",
    projectLink: "https://andremourapassos.com",
    repositoryUrl: "https://github.com/andremourapassos/andre-moura-passos",
    commitStart: "2024-12-05",
    commitEnd: "2026-04-11",
    architectureDomains:
      "Site core com roteamento por idioma e dominio, player de musica, catalogo GraphQL e fluxo de contato por API.",
    roadmap:
      "Foco atual em estabilidade local, validacao de backend, performance de startup e evolucao de conteudo multilanguage.",
    withoutAiHours: 180,
    withAiHours: 84,
    withAiLabel: "84h",
    withoutAiLabel: "180h",
    icon: "AMP",
    mockTheme: "wine",
  },
];

export const strategicAssets = [
  {
    name: "ia-mds",
    role: "Sistema pessoal de apoio para engenharia de contexto, padroes e aceleracao de entrega.",
  },
  {
    name: "Markdowns de produto",
    role: "Base de decisao e memoria operacional distribuida entre projetos como petinga e outros.",
  },
];
